<template>
  <div>
    <v-dialog v-model="show" @click:outside="closeDialog">
      <v-card>
        <v-card-title>
          <v-progress-linear
            indeterminate
            color="teal"
            v-if="loading"
          ></v-progress-linear>

          <strong> {{ $t("vca.history") }} </strong>
        </v-card-title>

        <v-card-text>
          <v-row>
            <!-- <v-col cols="12">
              <SSRTable ref="list-history" :data="transformedHistory" :schema="historySchema">
                <div slot="createdAt" slot-scope="{item}">
                  {{ tsToDateString(item.createdAt) }}
                </div>
              </SSRTable>
            </v-col> -->
            <v-col cols="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th v-for="col in historySchema" :key="col.value">
                        {{ col.text }}
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <template
                      v-if="transformedHistory.length > 0"
                      v-for="t in transformedHistory"
                    >
                      <tr :key="`history-${t.uniqueKey}`">
                        <td v-for="col in historySchema" :key="col.value">
                          {{ t[col.value] }}
                        </td>
                        <td width="20%">
                          <v-btn
                            fab
                            x-small
                            color="info"
                            @click="showTransactionDetail(t)"
                            :disabled="!t.paymentResults"
                          >
                            <v-icon>
                              {{
                                expandedContexts[t.uniqueKey]
                                  ? "mdi-chevron-up"
                                  : "mdi-chevron-down"
                              }}
                            </v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <tr
                        v-if="expandedContexts[t.uniqueKey]"
                        :key="`detail-${t.uniqueKey}`"
                      >
                        <td :colspan="historySchema.length + 1" class="pa-0">
                          <v-expand-transition>
                            <v-card outlined tile class="ma-0 pa-2">
                              <v-card-text>
                                <v-simple-table>
                                  <template v-slot:default>
                                    <thead>
                                      <tr>
                                        <th
                                          v-for="col in paymentResultSchema"
                                          :key="col.value"
                                        >
                                          {{ col.text }}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-if="!expandedContexts[t.uniqueKey].length">
                                        <td
                                          :colspan="paymentResultSchema.length + 1"
                                          class="text-center text--secondary py-4"
                                        >
                                          {{ $t("vca.noData") }}
                                        </td>
                                      </tr>
                                      <template
                                        v-if="expandedContexts[t.uniqueKey].length > 0"
                                        v-for="(item,
                                        index) in expandedContexts[t.uniqueKey]"
                                      >
                                        <tr :key="`exp-${index}`">
                                          <td
                                            v-for="col in paymentResultSchema"
                                            :key="col.value"
                                          >
                                            <span
                                              v-if="col.value === 'created_at'"
                                            >
                                              {{
                                                tsToDateString(item[col.value])
                                              }}
                                            </span>
                                            <span v-else>
                                              {{ item[col.value] }}
                                            </span>
                                          </td>
                                        </tr>
                                      </template>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-card-text>
                            </v-card>
                          </v-expand-transition>
                        </td>
                      </tr>
                    </template>

                    <tr v-if="!transformedHistory.length">
                      <td
                        :colspan="historySchema.length + 1"
                        class="text-center text--secondary py-4"
                      >
                        {{ $t("vca.noData") }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import SSRTable from "@/components/SSRTable";
import moment from "moment";

export default {
  name: "HistoryDialog",
  components: {
    SSRTable
  },
  props: {
    show: Boolean,
    vcaId: String,
    vcaType: String
  },

  mounted() {},

  methods: {
    closeDialog() {
      this.$emit("update:show", false);
    },

    fetchVcaHistory() {
      if (!this.vcaId || !this.vcaType) {
        this.$notify({
          text: `Failed to fetch vca information. Type and id are required.`,
          type: "error"
        });
        return;
      }
      this.loading = true;
      axios
        .get(
          `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/vca/transaction-history/${this.vcaType}/${this.vcaId}`
        )
        .then(response => {
          this.vca = response.data;
        })
        .catch(err => {
          console.error(`Failed to fetch vca information.`, err.response);
          this.$notify({
            text: `Failed to fetch vca information.`,
            type: "error"
          });
          this.vca = {};
        })
        .finally(() => {
          this.loading = false;
        });
    },
    tsToDateString(ts) {
      if (ts) {
        return moment.unix(ts).format("YYYY/MM/DD HH:mm:ss");
      }
      return "";
    },

    showTransactionDetail(t) {
      console.log("showTransactionDetail:" + t.uniqueKey);
      // 使用 uniqueKey 作為唯一的 key 來切換狀態
      const key = t.uniqueKey;

      // 檢查是否已經展開。如果已展開，則收合 (刪除 key)
      if (this.expandedContexts[key]) {
        this.$delete(this.expandedContexts, key);
      } else {
        // 如果未展開，則展開 (設定 key 和 context)
        this.$set(this.expandedContexts, key, t.paymentResults);
      }
    }
  },

  data() {
    return {
      loading: false,
      vca: {},
      expandedContexts: {}
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },
    transformedHistory() {
      const histories = this.vca.vcaHistory?.histories;

      if (!histories || !Array.isArray(histories)) {
        return []; // 若資料不存在或格式不對，回傳空陣列
      }

      const transformed = histories.map((item, index) => {
        const order = item.order || {};
        const vcnTransaction = item.vcnTransaction || {};
        const paymentData = item.paymentData || {};
        const errorMessage = vcnTransaction.context?.error || null;
        // 嘗試安全地取得 paymentOrderId
        const paymentOrderId =
          paymentData.paymentOrder?.payment_order_id || null;

        const paymentResults = paymentData.paymentResults || [];
        // 新增一個唯一的 ID。這裡使用 paymentOrderId，若無則使用索引。
        const uniqueKey = paymentOrderId || `temp_${index}`;
        return {
          // 欄位定義：
          uniqueKey: uniqueKey,
          vcaStatus: vcnTransaction.status
            ? this.$t(`vca.vcaStatus.${vcnTransaction.status}`)
            : null,
          updatedAt: vcnTransaction.updatedAt
            ? this.tsToDateString(vcnTransaction.updatedAt)
            : null,
          transactionStatus: vcnTransaction.transactionStatus
            ? this.$t(
                `vca.transactionStatus.${vcnTransaction.transactionStatus}`
              )
            : null,
          transactionDate: vcnTransaction.transactionDate
            ? this.tsToDateString(vcnTransaction.transactionDate)
            : null,
          refundStatus: vcnTransaction.refundStatus
            ? this.$t(`vca.refundStatus.${vcnTransaction.refundStatus}`)
            : null,
          // 根據 vcnTransaction.refundAt (null) 進行映射
          refundDate: vcnTransaction.refundAt
            ? this.tsToDateString(vcnTransaction.refundAt)
            : null,
          // context: vcnTransaction.context || null,
          errorMessage: errorMessage,
          paymentResults: paymentResults,
          paymentOrderId: vcnTransaction.ddpgOrderId || paymentOrderId
        };
      });
      // console.log("transformed:", transformed);
      return transformed;
    },
    historySchema() {
      return [
        { value: "updatedAt", text: this.$t("vca.updatedAt"), sortable: false },
        {
          value: "vcaStatus",
          text: this.$t("vca.vcaStatus.title"),
          sortable: false
        },
        {
          value: "paymentOrderId",
          text: this.$t("vca.paymentOrderId"),
          sortable: false
        },
        {
          value: "transactionStatus",
          text: this.$t("vca.transactionStatus.title"),
          sortable: false
        },
        {
          value: "transactionDate",
          text: this.$t("vca.transactionDate"),
          sortable: false
        },
        {
          value: "refundStatus",
          text: this.$t("vca.refundStatus.title"),
          sortable: false
        },
        {
          value: "refundDate",
          text: this.$t("vca.refundDate"),
          sortable: false
        },
        {
          value: "errorMessage",
          text: this.$t("vca.errorMessage"),
          sortable: false
        }
      ];
    },
    paymentResultSchema() {
      return [
        {
          value: "created_at",
          text: this.$t("vca.pyamentResult.createdAt"),
          sortable: false
        },
        {
          value: "action",
          text: this.$t("vca.pyamentResult.action"),
          sortable: false
        },
        {
          value: "message",
          text: this.$t("vca.pyamentResult.message"),
          sortable: false
        }
      ];
    }
  },

  watch: {
    vcaId: {
      immediate: false,
      handler(id) {
        if (id) {
          this.vca = {};
          this.expandedContexts = {};
          this.fetchVcaHistory();
        }
      }
    }
  }
};
</script>
